import React, { useState, useEffect } from "react";
import { LoadingOverlay, Stack, Title } from "@mantine/core";
import { useApp } from "../context/AppContext";
import BusinessInfoForm from "./forms/BusinessInfoForm";
import { useSalon } from "../context/SalonContext";
import { useNavigate } from "react-router-dom";
function BusinessInfoPage() {
  const navigate = useNavigate();
  const { businessInfo, setBusinessInfo, isMissingSalon } = useSalon();
  const { createSalon, updateSalon } = useApp();
  const [currentData, setCurrentData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // SalonContext's boot fetch is the single source of the current salon
  // record (multi-location aware). The old fallback here re-fetched
  // getSalons()[0], which after a location switch resurrects the OLD salon
  // (legacy salon_staff link) — so wait for the context instead.
  useEffect(() => {
    if (businessInfo) {
      setCurrentData(businessInfo);
      setIsLoading(false);
    } else if (isMissingSalon === true) {
      // Boot finished and there is genuinely no salon (new Owner).
      setCurrentData({});
      setIsLoading(false);
    }
    // else: SalonContext still booting → keep the loader up.
  }, [businessInfo, isMissingSalon]);

  const handleSubmit = async (businessData) => {
    setIsLoading(true);
    try {
      if (!businessData) {
        navigate("/business-hours");
      } else {
        const response = businessInfo
          ? await updateSalon(businessData)
          : await createSalon(businessData);

        if (response) {
          // PUT /business-locations returns ONLY the fields it updated — MERGE into the
          // existing record instead of replacing it, or every other field
          // (timezone, stripe ids, subscription status, ...) vanishes from
          // context and later whole-record writes corrupt the DB row. Same
          // pattern as AccountCreationPage.
          setBusinessInfo((prev) => ({ ...(prev || {}), ...response }));
          navigate("/business-hours");
        }
      }
    } catch (error) {
      const createOrUpdate = businessInfo ? "update" : "create";
      console.error(`Error with ${createOrUpdate} salon:`, error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Stack>
      <LoadingOverlay visible={isLoading} overlayProps={{ blur: 2 }} />
      <Stack
        p={{ base: "0", sm: "md", md: "xl" }}
        w="90%"
        maw="60rem"
        mx="auto"
        align="center"
      >
        <Title order={2} c="gray.8">
          Confirm your business information
        </Title>
        <BusinessInfoForm
          initialData={currentData}
          onSubmit={handleSubmit}
          isEditing={!!businessInfo}
        />
      </Stack>
    </Stack>
  );
}

export default BusinessInfoPage;
